import React, { useEffect, useRef, useState } from "react";
import styles from "./index.module.scss";
import {
  Link,
  useNavigate,
  useParams,
  useSearchParams
} from "react-router-dom";
import { countDaysFromDate, formatCurrency } from "../../../utils/utils";
import ButtonC from "../button";
import MobileDetailsSidebar from "./mobile-details-sidebar";
import MobilePlaceBidSlider from "./mobile-place-bid-sidebar";
import { numberWithCommas } from "../../../utils/const";
import { useCreateShareLink } from "../../../hooks/react-query/properties/useCreateShareLink";
import CopyLink from "../../../pages/property/property-details/copy-link";
import { Sidebar } from "primereact/sidebar";
import {
  ContactAgents,
  TotalPropertyImageViewed
} from "../../investor/amplitude";
import { OverlayPanel } from "primereact/overlaypanel";
import Like from "../like";
import useContextHook from "../../../hooks/context/useContext";
import { useToast } from "../toast/toast";
import { useContactAgent } from "../../../hooks/react-query/investor/useContactAgent";
import moment from "moment";
import { Tag } from "primereact/tag";
import PriceDropTag from "../pricedrop-tag";

export default function MobileDetailsScreen({
  objPropertyDetails,
  status,
  loading,
  type
}: any) {
  const [visibleBottom, setVisibleBottom] = React.useState(false);
  const [dragging, setDragging] = React.useState(false);
  const [visibleShare, setVisibleShare] = React.useState(false);
  const [searchParams] = useSearchParams(window.location.search);
  const [showThankYou, setShowThankYou] = useState(false);
  // const searchParams: any = new URLSearchParams(window.location.search);
  const [visiblePlaceBid, setVisiblePlaceBid] = React.useState<boolean>(
    (!!searchParams.get("bid") && window.innerWidth < 600) || false
  );
  const [startY, setStartY] = React.useState(0);
  const [currentY, setCurrentY] = React.useState(0);
  const { propertyId } = useParams();
  const { mobileNumber } = useContextHook();
  const cid = searchParams.get("cid") || "";
  const eq = searchParams.get("eq") || "";
  const { showError }: any = useToast();

  const ContactAgentMutation = useContactAgent(
    (data: any) => {
      setShowThankYou(true);
      ContactAgents({
        propertyId: objPropertyDetails?.propertyId,
        propertySFID: objPropertyDetails?.propertySFID,
        shareId: propertyId || "",
        pubPropertySFID: objPropertyDetails?.pubPropertySFID,
        opportunitySFID: objPropertyDetails?.opportunitySFID,
        linkCId: cid,
        linkEmailId: eq,
        ...(mobileNumber && { mobileNumber: mobileNumber })
      });
    },
    (error) => {
      showError("error", error.response.data.message || "something went wrong");
    }
  );
  const navigate = useNavigate();
  // const { data: internalShareLink, isLoading: isLoadingInternal } =
  //   useCreateShareLink("internal", objPropertyDetails?.id);

  // const { data: externalShareLink, isLoading } = useCreateShareLink(
  //   "external",
  //   objPropertyDetails?.id
  // );
  const handleTouchStart = (e: React.TouchEvent) => {
    setDragging(true);
    setStartY(e.touches[0].clientY);
  };

  const handleTouchMove = (e: React.TouchEvent) => {
    if (!dragging) return;
    const deltaY = e.touches[0].clientY - startY;
    setCurrentY(deltaY);
  };

  const handleTouchEnd = () => {
    setDragging(false);
    if (currentY < -50) {
      setVisibleBottom(true);
    } else if (currentY > 50) {
      setVisibleBottom(false);
    }
    setCurrentY(0);
  };
  const { data: internalShareLink, isLoading: isLoadingInternal } =
    useCreateShareLink("internal", objPropertyDetails?.id, type);

  const { data: externalShareLink, isLoading } = useCreateShareLink(
    "external",
    objPropertyDetails?.id,
    type
  );

  const galleryRef = useRef<HTMLDivElement | null>(null);
  const observerRef = useRef<IntersectionObserver | null>(null);
  const op = useRef<any>(null);
  const [viewedImages, setViewedImages] = useState(new Set());
  const [totalPropertyImagesViewed, setTotalPropertyImagesViewed] = useState(0);

  useEffect(() => {
    if (type === "investor") {
      if (!galleryRef.current) return;
      observerRef.current = new IntersectionObserver(
        (entries) => {
          let newViewedImages = new Set(viewedImages);
          let newCount = totalPropertyImagesViewed;

          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const imgElement = entry.target as HTMLImageElement;
              const imgSrc =
                imgElement.getAttribute("data-src") || imgElement.src;
              if (
                !!objPropertyDetails &&
                imgSrc &&
                !newViewedImages.has(imgSrc)
              ) {
                newViewedImages.add(imgSrc);
                newCount++;
                TotalPropertyImageViewed({
                  totalImagesViewed: +newCount,
                  propertyId: objPropertyDetails?.propertyId,
                  opportunitySFID: objPropertyDetails?.opportunitySFID,
                  pubPropertySFID: objPropertyDetails?.pubPropertySFID,
                  propertySFID: objPropertyDetails?.propertySFID,
                  shareId: propertyId || "",
                  linkCId: cid,
                  linkEmailId: eq,
                  ...(mobileNumber && { mobileNumber: mobileNumber })
                });
              }
            }
          });

          if (newViewedImages.size !== viewedImages.size) {
            setViewedImages(newViewedImages);
            setTotalPropertyImagesViewed(newCount);
          }
        },
        { threshold: 0.5 }
      );

      const images = galleryRef.current.querySelectorAll("img");
      images.forEach((img) => observerRef.current?.observe(img));
      return () => observerRef.current?.disconnect();
    }
  }, [viewedImages, totalPropertyImagesViewed, objPropertyDetails]);

  const isVideo = (url: string) => {
    return url?.match(/\.(mp4|mov|avi|wmv|flv|mkv)$/i) ? true : false;
  };

  const renderMedia = (media: any, index: number) => {
    const isVideoFile = isVideo(media?.url);

    if (isVideoFile) {
      return (
        <video key={index} autoPlay muted loop playsInline data-src={media.url}>
          <source src={media.url} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      );
    }

    return <img src={media.url} alt="" data-src={media.url} />;
  };

  return (
    <div className={styles.MobileDetails}>
      <MobileDetailsSidebar
        type={type}
        visibleBottom={visibleBottom}
        Status={status}
        setVisibleBottom={setVisibleBottom}
        objPropertyDetails={objPropertyDetails}
        setVisiblePlaceBid={setVisiblePlaceBid}
      />
      <MobilePlaceBidSlider
        visiblePlaceBid={visiblePlaceBid}
        setVisiblePlaceBid={setVisiblePlaceBid}
        objPropertyDetails={objPropertyDetails}
      />
      <Sidebar
        visible={visibleShare}
        position="bottom"
        onHide={() => setVisibleShare(false)}
        className={styles.mobileSidebar}
      >
        <CopyLink
          visibleShare={visibleShare}
          setVisibleShare={setVisibleShare}
          internalShareLink={internalShareLink}
          externalShareLink={externalShareLink}
          isMobile={window.innerWidth < 600}
        />
      </Sidebar>

      <div
        className={styles.closeIcon}
        onClick={() => {
          navigate(-1);
        }}
      >
        <div className={styles.closeWrap}>
          <img src="/images/close.svg" alt="" width={35} height={35} />
          {type !== "investor" && (
            <Tag
              className={styles.tagClass}
              value={
                countDaysFromDate(objPropertyDetails?.createdAt) > 1
                  ? `${countDaysFromDate(objPropertyDetails?.createdAt)} Days ago`
                  : `${countDaysFromDate(objPropertyDetails?.createdAt)} Day ago`
              }
              style={{ background: "#0000008a", color: "#ffffff" }}
            />
          )}
        </div>
      </div>
      {type === "investor" && (
        <div className={styles.LikeShare}>
          <i
            className="pi pi-question-circle"
            onClick={(e: any) => op?.current?.toggle(e)}
          />
          <Like
            loginType={type}
            propertyId={objPropertyDetails?.id}
            favCount={objPropertyDetails?.favCount}
            isMobile={true}
            objPropertyDetails={objPropertyDetails}
          />
          <OverlayPanel
            ref={op}
            closeOnEscape
            dismissable
            className={styles.dialog}
          >
            <div className={styles.header}>Technical support</div>
            <div className={styles.content}>
              Email us at{" "}
              <Link to="mailto:support@ftreca.com">support@ftreca.com</Link> for
              technical support
            </div>
          </OverlayPanel>
        </div>
      )}
      {type !== "investor" && (
        <div
          className={`${styles.LikeShare} ${styles.LikeShareMobile} ${
            process.env.REACT_APP_ENABLE_SHARE !== "true"
              ? `${styles.NoShare}`
              : ""
          }`}
        >
          {!isLoadingInternal && !isLoading && (
            <img
              src="/images/share.svg"
              width={24}
              alt=""
              onClick={() => setVisibleShare(true)}
            />
          )}
          <Like
            loginType="agent"
            propertyId={objPropertyDetails?.id}
            favCount={objPropertyDetails?.favCount}
            isMobile={true}
            objPropertyDetails={objPropertyDetails}
          />
        </div>
      )}
      <div
        ref={galleryRef}
        className={`${styles.propertyDetailsImg} ${
          type === "investor" || objPropertyDetails?.status === "Sold"
            ? `${styles.soldHeight}`
            : ""
        }`}
      >
        {objPropertyDetails?.images?.length > 0 ? (
          objPropertyDetails?.images &&
          objPropertyDetails?.images.map((image: any, index: number) => (
            <React.Fragment key={image?.url}>
              {renderMedia(image, index)}
            </React.Fragment>
          ))
        ) : (
          <div className={styles.full}>
            <img src="/images/no-img-details.png" alt="user" />
            <span className={styles.notFound}>Images Not Found</span>
          </div>
        )}
      </div>
      <div className={styles.DetailsInfo}>
        {type === "investor" && (
          <>
            {showThankYou ? (
              <div className={styles.thankYouBox}>
                <span className={styles.bellIcon}>
                  <img src="/images/bell.svg" alt="" />
                </span>
                <span className={styles.thankYouText}>
                  Thanks for reaching out! One of our agents will be in touch
                  soon to share more details and help you explore this
                  opportunity further.
                </span>
              </div>
            ) : (
              <div className={styles.connectWithAgent}>
                <div className={styles.message}>
                  Want to Explore This Investment?
                </div>
                {!ContactAgentMutation?.isPending ? (
                  <img
                    src="/images/yes-connect-agent.svg"
                    alt=""
                    onClick={(e) => {
                      e.stopPropagation();
                      ContactAgentMutation.mutate({
                        pubPropertyId: objPropertyDetails.id,
                        date: moment().format("MM-DD-YYYY hh:mm:ss A")
                      });
                    }}
                  />
                ) : (
                  <img
                    src="/images/yes-connect-agent.svg"
                    alt=""
                    style={{ opacity: 0.7 }}
                  />
                )}
              </div>
            )}
          </>
        )}
        <div
          className={styles.DetailWrapper}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
          onClick={() => setVisibleBottom(true)}
        >
          <div
            className={styles.headerBar}
            onClick={() => setVisibleBottom(true)}
          >
            <img src="/images/uparrow.svg" alt="" />
          </div>
          <PriceDropTag
            type={type}
            priceDrop={objPropertyDetails?.priceDrop}
            priceDropDate={objPropertyDetails?.priceDropDate}
          />
          <div className={styles.price}>
            {formatCurrency(+objPropertyDetails?.askingPrice, "USD", "en-us")}
          </div>
          <div className={styles.address}>{objPropertyDetails?.address}</div>
          <div className={styles.accessories}>
            {objPropertyDetails?.bedRooms && (
              <div className={styles.accessory}>
                <img src="/images/bed.svg" alt="" />
                <span>{objPropertyDetails?.bedRooms}</span>
              </div>
            )}
            {(objPropertyDetails?.baths || objPropertyDetails?.totalBath) && (
              <div className={styles.accessory}>
                <img src="/images/bath.svg" alt="" />
                <span>
                  {objPropertyDetails?.baths || objPropertyDetails?.totalBath}
                </span>
              </div>
            )}
            {objPropertyDetails?.garage && (
              <div className={styles.accessory}>
                <img src="/images/car.svg" alt="" />
                <span>{objPropertyDetails?.garage}</span>
              </div>
            )}
            {objPropertyDetails?.sqft && (
              <div className={styles.accessory}>
                <img src="/images/sqft.svg" alt="" />
                <span>{numberWithCommas(objPropertyDetails?.sqft)}</span>
              </div>
            )}
            {objPropertyDetails?.lotSizeSqFt && (
              <div className={styles.accessory}>
                <img src="/images/sqft.svg" alt="" />
                <span>{numberWithCommas(objPropertyDetails?.lotSizeSqFt)}</span>
              </div>
            )}
          </div>
          {objPropertyDetails?.status === "Sold" && (
            <div className={styles.Note}>
              Biding time period is closed on this property.
            </div>
          )}
          {type !== "investor" && (
            //  &&
            //   (objPropertyDetails?.offerDueDateAndTime === null ||
            //     moment(objPropertyDetails?.offerDueDateAndTime).isAfter(
            //       moment().utc()
            //     ))
            <ButtonC
              type="button"
              label="Place Bid"
              size="medium"
              tabIndex={29}
              className={styles.btn}
              disabled={objPropertyDetails?.status === "Sold"}
              onClick={(e: any) => {
                e.stopPropagation();
                setVisiblePlaceBid(true);
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
